import { env } from '@ria-client/env';
import { LinkType } from '@ria-client/segment/enums';
import { EntityPlacementCtaTypeEnum } from '@ria-client/supergraph/marketplace/enums';
import { TrackedLink } from '@ria-client/tw-shared-ui';
import { StructuredContentRenderer, type StructuredContentRendererProps } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';
import { ContentLink } from './lib/content-link';

interface LinkNodeProps extends Record<string, unknown> {
  children: StructuredContent | StructuredContent[];
  href?: string;
  target?: string;
}

interface LinkRendererProps {
  nested?: boolean;
}

export type LinkProps = NodeProps<LinkNodeProps> &
  Pick<StructuredContentRendererProps, 'productCardBottomLineCtaData'> &
  LinkRendererProps;

export function Link({ productCardBottomLineCtaData, props }: LinkProps) {
  return (
    <>
      {[props.children].flat().map((child, index) => {
        if (typeof child === 'string') {
          if (
            props.href?.includes(`${env.NEXT_PUBLIC_NW_URL}/redirect/`) &&
            productCardBottomLineCtaData
          ) {
            return (
              <TrackedLink
                analyticsPayload={productCardBottomLineCtaData.ctaAnalytics}
                cta={{
                  ...productCardBottomLineCtaData.cta,
                  type: EntityPlacementCtaTypeEnum.RestOfProductCard,
                }}
                key={index}
                linkType={LinkType.REST_OF_PRODUCT_CARD}
                monetizable={productCardBottomLineCtaData.ctaAnalytics.monetizable}
              >
                {child}
              </TrackedLink>
            );
          }

          return (
            <ContentLink
              key={index}
              className="text-secondary-foreground no-underline hover:underline"
              href={props.href}
              target={props.target}
            >
              {child}
            </ContentLink>
          );
        }
        if (!child) return null;

        return (
          <ContentLink
            key={index}
            className="text-secondary-foreground no-underline hover:underline"
            href={props.href}
            target={props.target}
          >
            <StructuredContentRenderer doc={child} />
          </ContentLink>
        );
      })}
    </>
  );
}
